import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import * as constants from "../../widgetConstants.js";
import {getNoData} from "../../items/index.js";
import Widget from "../widget.js";
import u from "../../../../util/index.js";

export class MentionWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {
        const inputData = {
            ...this.$props.pageData,
            GUBUN: "MENTION",
            TMPL_TYPE: "",
        }

        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {
            recordData: data[this.$props.RECORD]
        };
    }

    async render() {
        $(this.$target).empty()
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('mention'),
            callback: {
                // scroll: () => this.setup.bind(this)({isDataDrivenRendering: true}),
                item: getMentionPostsHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
    }
}

/* 나를 언급 아이템 dom으로 변환하여 반환하는 함수*/
const getMentionPostsHtmByRecord = (allPostsArray) => {
    return allPostsArray.map((v) => getMentionItem(v)).join('');
}

/* 멘션 아이템 단건으로 li 반환*/
const getMentionItem = (item) => {
    const {
        COLABO_COMMT_SRNO,
        COLABO_SRNO,
        COLABO_REMARK_SRNO,
        READ_YN,
        TMPL_TYPE,
        CNTN
    } = item
    const tmplType = Often.null2Void(TMPL_TYPE, "1");
    const isRemark = tmplType === "-1";
    const post_gb = (isRemark ? "comment2 comment" : DetailCode.POST._GB[tmplType]);
    const not_read = ("N" === Often.null2Void(READ_YN, "N")) ? "alarm" : "";

    return `<li id="allPosts-${COLABO_COMMT_SRNO}" colabo_srno="${COLABO_SRNO}" colabo_commt_srno="${COLABO_COMMT_SRNO}" colabo_remark_srno="${COLABO_REMARK_SRNO}" class="js-all-post-item">
                    <span class="article-icon-wrap ${not_read}"><i class="icons-${post_gb}"></i></span>
                    <p>${Mutil.tag2html(Mutil.mentionData2Tag(CNTN))}</p>
                </li>`
}

/*태그가 포함된 글 내용 (이미지), (파일)로 변환하여 반환하는 함수*/
const cntn2text = (allPostsItem) => {
    let returnContents = Often.null2Void(allPostsItem.CNTN, "").replace(_USER_ID, "").replace(_USER_NM, "").trim();

    if (returnContents !== "") return returnContents;
    if (allPostsItem.SYS_CODE == "" || allPostsItem.SYS_CODE === null) return _USER_NM;

    try {
        const sysCode = JSON.parse(allPostsItem.SYS_CODE).SYS_CODE;

        returnContents = {
            S13: constants.imageIcon,
            S14: constants.fileIcon,
            S20: constants.imageIcon + " " + constants.fileIcon,
        }[sysCode]
    } catch (e) {
        //pass
    }
    return returnContents;
}
